export interface ApplicationUser {
  ExternalId: string;
  UserName: string;
  Name: string;
  Email: string;
  FirstName: string;
  LastName: string;
  TaxCode: string;
  BusinessName: string;
  VatCode: string;
  AddresseeCode: string;
  MobilePhoneNumber: number;
  PhoneNumber: number;
  Fax: number;
  Address: string;
  CAP: number;
  City: string;
  StateOrProvince: string;
  PEC: string;
}

export class ApplicationUserClass implements ApplicationUser {
  ExternalId: string = '';
  UserName: string = '';
  Email: string = '';
  FirstName: string = '';
  LastName: string = '';
  Name: string = '';
  TaxCode: string = '';
  BusinessName: string = '';
  VatCode: string = '';
  AddresseeCode: string = '';
  MobilePhoneNumber: number = 0;
  PhoneNumber: number = 0;
  Fax: number = 0;
  Address: string = '';
  CAP: number = 0;
  City: string = '';
  StateOrProvince: string = '';
  PEC: string = '';
}
